module.exports = __webpack_public_path__ + "static/media/sneakpeek-message-background.952f088f.png";